import React from 'react';
import './dropdown-input-bar.css';

class DropdownInputBar extends React.Component {
  render() {
    const { children, text, iconName, onClick, check, isDefault } = this.props;
    return (
      <div className="dropdown-input-bar" onClick={onClick}>
        {children}
        <span className="dropdown-input-bar-text">
          {check && <i className="ui icon green check" />}
          {text}
          {isDefault && <span className="gray">&nbsp;(Default)</span>}
        </span>
        <div className="dropdown-input-bar-icon">
          <i className={`ui icon ${iconName}`} />
        </div>
      </div>
    );
  }
}

export default DropdownInputBar;



// WEBPACK FOOTER //
// ./src/components/dropdown-input-bar/index.js